
import gql from 'graphql-tag'

// """给某个经销商分发多个商品"""
export const assignGoodsToDealer = gql`
  mutation($dealerId: Int!, $goods: [GoodProportionInput!]!) {
    assignGoodsToDealer(
      dealerId: $dealerId,
      goods: $goods
    )
  }
`

export const removeGoodsFromDealer = gql`
  mutation($dealerId: Int!, $goodIds: [Int!]!) {
    removeGoodsFromDealer(
      dealerId: $dealerId,
      goodIds: $goodIds
    )
  }
`

// """给经销商分配学校"""

export const updateDealerSchools = gql`
  mutation($dealerId: Int!, $schoolIds: [Int!]!) {
    updateDealerSchools(
      dealerId: $dealerId,
      schoolIds: $schoolIds
    ) {
      area {
        cityCode
        createdAt
        id
        ing
        lat
        levelType
        managers {
          createdBy {
            id
            username
          }
          modifiedBy {
            id
            username
          }
        }
        mergerName
        name
        parentId
        pinyin
        shortName
        updatedAt
        zipCode
      }
      dealers {
        id
        realname
        storeName
        status
        user {
          phone
        }
      }
      areaId
      createdAt
      id
      managers {
        createdBy {
          id
          username
        }
        modifiedBy {
          id
          username
        }
      }
      name
      status
      updatedAt
    }
  }
`

// """经销商更改全部商品显示顺序(经销商)"""

export const updateDisplayOrder = gql`
  mutation($dealerId: Int!, $orders: [Int!]!) {
    updateDisplayOrder(
      dealerId: $dealerId,
      orders: $orders
    ) {
      id
    }
  }
`
// orders商品数组的id
// """经销商更改某个商品的显示顺序(经销商)"""
export const updateGoodDisplayOrder = gql`
  mutation($dealerId: Int!, $goodId: Int!, $order: Int!) {
    updateGoodDisplayOrder(
      dealerId: $dealerId,
      goodId: $goodId,
      order: $order
    ) {
      id
    }
  }
`

// 查询经销商的商品排序
export const findGoodsDisplayOrderByDealerId = gql`
query($dealerId: Int!) {
    findGoodsDisplayOrderByDealerId(
      dealerId: $dealerId,
    ) {
      dealerId
      displayOrders
    }
  }
`
